import { Space, Typography } from 'antd';
import StatusLabel from 'components/new-ui/base/status-label/StatusLabel';
import { dutyPayerLabels, vatTreatmentLabels } from 'store/customers/customer';
import { usePartyContext } from 'views/customers/customer/PartyProvider';
import { FieldLabel, FormCol, FormRow } from '../../Utils';

type Props = {
    showAEP5Section: boolean;
};

const NotConfigured = () => <StatusLabel isPositive={false} positiveText="" negativeText="Not Configured" />;

const DutyAndVatView = ({ showAEP5Section }: Props) => {
    const { customer } = usePartyContext();

    const { dutyPayer, vatTreatment, vatExemption } = customer.customerDetails ?? {};
    const hasAEP5Verified = !!customer.customerDetails?.confirmedTanUsage;
    const hasAEP5Uploaded = !!customer.customerDetails?.aep5Verified;

    return (
        <Space size={16} direction="vertical" style={{ width: '100%', marginTop: 16 }}>
            <FormRow>
                <FormCol>
                    <FieldLabel>Duty Payer</FieldLabel>
                    {dutyPayer ? (
                        <Typography.Text style={{ fontWeight: 600 }}>{dutyPayerLabels[dutyPayer]}</Typography.Text>
                    ) : (
                        <NotConfigured />
                    )}
                </FormCol>
                <FormCol>
                    <FieldLabel>VAT Treatment</FieldLabel>
                    {vatTreatment ? (
                        <Typography.Text style={{ fontWeight: 600 }}>
                            {vatTreatmentLabels[vatTreatment]}
                        </Typography.Text>
                    ) : (
                        <NotConfigured />
                    )}
                </FormCol>
            </FormRow>

            <FormRow>
                <FormCol>
                    <FieldLabel>VAT Exemption</FieldLabel>
                    {vatExemption === undefined || vatExemption === null ? (
                        <NotConfigured />
                    ) : (
                        <Typography.Text style={{ fontWeight: 600 }}>{vatExemption ? 'Yes' : 'No'}</Typography.Text>
                    )}
                </FormCol>
            </FormRow>

            {/* The AEP5 data is required only when the Consignee (Current customer) is selected as Duty payer */}
            {showAEP5Section && (
                <FormRow>
                    <FormCol>
                        <FieldLabel>AEP5 Verification</FieldLabel>
                        <StatusLabel isPositive={hasAEP5Verified} positiveText="Verified" negativeText="Not Verified" />
                    </FormCol>
                    <FormCol>
                        <FieldLabel>AEP5 Document</FieldLabel>
                        <StatusLabel isPositive={hasAEP5Uploaded} positiveText="Uploaded" negativeText="Not Uploaded" />
                    </FormCol>
                </FormRow>
            )}
        </Space>
    );
};

export default DutyAndVatView;
